export default __webpack_public_path__ + "static/media/search-icon.e4ef1e1b.svg";